module.exports = __webpack_public_path__ + "img/Graphic-Centered.fdd06ebd.gif";